import IconButton from "@material-ui/core/IconButton";
import { makeStyles, Theme } from "@material-ui/core/styles";
import React, { useState } from "react";
import { LockOpen, Lock } from "@material-ui/icons";
import { GetTranslation } from "../../translations/GetTranslation";
import { useIntl } from "react-intl";
import { TranslationKey } from "../../translations/TranslationKey";

interface SecretTextProps {
  text: string;
  label: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));

const SecretText: React.FunctionComponent<SecretTextProps> = ({ text, label }) => {
  const intl = useIntl();
  const classes = useStyles();
  const [isRevealed, setIsRevealed] = useState(false);

  if (!text) {
    return null;
  }

  return (
    <>
      {!isRevealed && (
        <div className={classes.wrapper}>
          <span>{"*".repeat(8)}</span>
          <IconButton onClick={() => setIsRevealed(true)} size="small">
            <LockOpen titleAccess={GetTranslation(intl, label as TranslationKey)} />
          </IconButton>
        </div>
      )}
      {isRevealed && (
        <div className={classes.wrapper}>
          <span>{text}</span>
          <IconButton onClick={() => setIsRevealed(false)} size="small">
            <Lock />
          </IconButton>
        </div>
      )}
    </>
  );
};

export default SecretText;
